var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"checkout-builder-image-preview"},[_c('img',{style:(_vm.style),attrs:{"src":_vm.component.image,"alt":"imagem"}})])}
var staticRenderFns = []

export { render, staticRenderFns }